<template>
  <BaseSvg class="arrow-back-icon" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.5 10L10.8333 10"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 15.8335L2.5 10.0002L10 4.16683L10 15.8335Z"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseSvg>
</template>

<script>
import { BaseSvg } from '@clovyr/bed';

export default {
  name: 'ArrowBackIcon',
  components: {
    BaseSvg,
  },
};
</script>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/util';

.arrow-back-icon {
  @include util.size(util.rem(20), util.rem(20));
}
</style>
